import { makeAutoObservable } from 'mobx';

export interface IMnemoInfo {
    path: string;
    bindings: string;
}
class SystemStore {
    private _loadState: boolean = false;
    private _message: string = '';
    private _mnemoInfo: IMnemoInfo = {
        path: '',
        bindings: ''
    };

    constructor() {
        makeAutoObservable(this);
    }

    public get loadState() {
        return this._loadState;
    }

    public set loadState(value: boolean) {
        this._loadState = value;
    }

    public get message() {
        return this._message;
    }

    public set message(value: string) {
        this._message = value;
    }

    public get mnemoPath() {
        return this._mnemoInfo;
    }

    public set mnemoPath(value: IMnemoInfo) {
        this._mnemoInfo = value;
    }

    setLoad = () => {
        if (window.GetConnectState()) {
            this._loadState = true;
        } else {
            setTimeout(() => {
                this.setLoad();
            }, 1000);
        }
    };
}

export default SystemStore;
